module.exports = __webpack_public_path__ + "static/enfant-photographe-e12773ac36da41705b00c52b7303e59a.png";